import { useQuery } from '@powersync/react';
import { useRef } from 'react';

import { sortKeyAfter } from '@flow/domain';
import { queries } from '@flow/sync';

/**
 * Sort key for the next block created at the end of the list (docs/08 §5). The last key comes from
 * a reactive query, which lags behind a burst of captures (it is re-run after each write and
 * throttled): the keys used since the last result are remembered here so consecutive captures keep
 * the order in which they were written (f1-local-write-latency, «Ráfaga de escrituras»).
 */
export function useNextSortKey(workspaceId: string): () => string {
  const lastKeyQuery = queries.lastSortKey(workspaceId);
  const { data } = useQuery<{ last: string | null }>(lastKeyQuery.sql, lastKeyQuery.params);
  const watched = data[0]?.last ?? null;
  const used = useRef<string | null>(null);

  return () => {
    const previous = used.current;
    const base = previous !== null && (watched === null || previous > watched) ? previous : watched;
    const next = sortKeyAfter(base);
    used.current = next;
    return next;
  };
}
